module.exports = __webpack_public_path__ + "fonts/analogue-italic-webfont.4dd4ce8.ttf";